<template>
  <div id="footerNew2020">  

        <div id="footerFirstContainer">
            <div class="footerSectionWrapper">
    
                <div class="footerColumn fCol1">
                    <div class="footerColumnWrapper">
                      <div v-if="!this.$root.isMedUK && !this.$root.isNutriverse"> 
                        <a class="companyLogo" href="/">
                            <img class="pnLogo" width="238" height="48" alt="logo" loading="lazy" src="/CKFinderJava/userfiles/images/2014/general/Logo-PN-no-slogan-0514.png?w=238" />
                        </a>
                        <p class="companyDesc-text">
                            <webmessage :text="this.$root.language.wsm_Footer2020_companyDescription" searchKey="wsm_Footer2020_companyDescription"></webmessage>
                        </p>
                      </div>
                      <div>
                        <!-- <h4 class="footer-infoHeader">{{this.$root.language.wsm_Address}} <i class="fas fa-map-marker-alt"></i></h4> -->
                        <h4 class="footer-infoHeader">
                            <webmessage :text="this.$root.language.wsm_Address" searchKey="wsm_Address"></webmessage> <i class="fas fa-map-marker-alt"></i>
                        </h4>
                        <p v-if="this.$root.isThai" v-html="this.$root.language.wsm_Thai_en_Footer2020_address"></p>
                        <p v-else>
                            <webmessage :text="this.$root.language.wsm_Footer2020_address" searchKey="wsm_Footer2020_address"></webmessage>
                        </p>
                      </div>
                    </div>
                </div>
    
                <div class="footerColumn fCol2">
                    <div v-if="this.$root.isThai" class="footerColumnWrapper">
                        
                        
                      <div>
                        <h4>
                            <webmessage :text="this.$root.language.wsm_Thai_en_OpeningHours" searchKey="wsm_Thai_en_OpeningHours"></webmessage>
                        </h4>
                        <p>
                            <webmessage :text="this.$root.language.wsm_Thai_en_phoneOpeningHoursMonToThurs" searchKey="wsm_Thai_en_phoneOpeningHoursMonToThurs"></webmessage>
                        </p>
                        <p>
                            <webmessage :text="this.$root.language.wsm_Thai_en_phoneOpeningHoursFriday" searchKey="wsm_Thai_en_phoneOpeningHoursFriday"></webmessage>
                        </p>
                        <h2>
                            <webmessage :text="this.$root.language.wsm_Thai_en_Footer2020_phone" searchKey="wsm_Thai_en_Footer2020_phone"></webmessage>
                        </h2>
                      </div>

                         <div class="soMeWrapper">
                            <a v-if="this.$root.facebookLink != undefined && this.$root.facebookLink !='' " :href="this.$root.facebookLink" target="_blank" >
                                <img src="/CKFinderJava/userfiles/images/general/SOME/Facebook.svg" alt="Facebook/Meta">                            
                            </a>
                            <a v-if="this.$root.channel != '' || this.$root.channel != undefined " :href="'https://www.youtube.com/channel/' + this.$root.channel" target="_blank">
                                <img src="/CKFinderJava/userfiles/images/general/SOME/yt_icon_mono_light.svg" alt="YouTube">                            
                            </a>
                             <a v-if="this.$root.linkedin != '' && this.$root.linkedin != undefined " :href="this.$root.linkedin" target="_blank" >
                                <img class="linkedIn"  src="/CKFinderJava/userfiles/images/general/SOME/LI-In-Bug-black-v2.svg" alt="LinkedIn">                            
                            </a>
                            <a v-if="this.$root.twitterLink != undefined && this.$root.twitterLink != ''" :href="this.$root.twitterLink" target="_blank" >
                                <img src="/CKFinderJava/userfiles/images/general/SOME/Twitter-social-icons-rounded-square.svg" alt="Twitter">                            
                            </a>
                             <a v-if="this.$root.instagramLink != undefined && this.$root.instagramLink !=''" :href="this.$root.instagramLink" target="_blank" >
                                <img src="/CKFinderJava/userfiles/images/general/SOME/glyph-logo_May2016.svg" alt="Instagram">                            
                            </a>                            
                            <!-- use the webmessage to add extra Icons to the right of the social media icons, country specific -->                           
                            <webmessage v-if="this.$root.language.wsm_Thai_en_Footer2020_socialMedia != 'false'"  :text="this.$root.language.wsm_Thai_en_Footer2020_socialMedia" searchKey="wsm_Footer2020_socialMedia" ></webmessage> 
                                  
                            
                          </div>
                    </div>
    
                    <div v-else class="footerColumnWrapper">

                      <div>
                        <h4 v-if="!this.$root.isNutriverse">
                            <webmessage :text="this.$root.language.wsm_OpeningHours" searchKey="wsm_OpeningHours"></webmessage>
                        </h4>
                        <h4 v-if="this.$root.isNutriverse">                           
                            <webmessage :text="this.$root.language.wsm_Footer2020_about" searchKey="wsm_Footer2020_about"></webmessage>
                        </h4>
                        
                        <p v-if="this.$root.isNutriverse">
                            <webmessage :text="this.$root.language.wsm_Footer2020_about_links" searchKey="wsm_Footer2020_about_links"></webmessage>
                        </p>
                        <p v-if="!this.$root.isNutriverse"> 
                            <webmessage :text="this.$root.language.wsm_phoneOpeningHoursMonToThurs" searchKey="wsm_phoneOpeningHoursMonToThurs"></webmessage>
                        </p>
                        <p>
                            <webmessage :text="this.$root.language.wsm_phoneOpeningHoursFriday" searchKey="wsm_phoneOpeningHoursFriday"></webmessage>
                        </p>
                        <h2>
                            <webmessage :text="this.$root.language.wsm_Footer2020_phone" searchKey="wsm_Footer2020_phone"></webmessage>
                        </h2>
                      </div>
                        <!-- <span>
                            <webmessage :text="this.$root.language.wsm_Footer2020_socialMedia" searchKey="wsm_Footer2020_socialMedia"></webmessage>
                        </span> -->
    

                        <div class="soMeWrapper" v-if="isSoMeLinkAvailable">
                            <a v-if="this.$root.facebookLink != undefined && this.$root.facebookLink !='' " :href="this.$root.facebookLink" target="_blank" >
                                <img src="/CKFinderJava/userfiles/images/general/SOME/Facebook.svg" alt="Facebook/Meta">                            
                            </a>
                            <a v-if="this.$root.channel != '' && this.$root.channel != undefined " :href="'https://www.youtube.com/channel/' + this.$root.channel" target="_blank">
                                <img src="/CKFinderJava/userfiles/images/general/SOME/yt_icon_mono_light.svg" alt="YouTube">                            
                            </a>
                             <a v-if="this.$root.linkedin != '' && this.$root.linkedin != undefined " :href="this.$root.linkedin" target="_blank" >
                                <img class="linkedIn"  src="/CKFinderJava/userfiles/images/general/SOME/LI-In-Bug-black-v2.svg" alt="LinkedIn">                            
                            </a>
                            <a v-if="this.$root.twitterLink != undefined && this.$root.twitterLink != ''" :href="this.$root.twitterLink" target="_blank" >
                                <img src="/CKFinderJava/userfiles/images/general/SOME/Twitter-social-icons-rounded-square.svg" alt="Twitter">                            
                            </a>
                             <a v-if="this.$root.instagramLink != undefined && this.$root.instagramLink !=''" :href="this.$root.instagramLink" target="_blank" >
                                <img src="/CKFinderJava/userfiles/images/general/SOME/glyph-logo_May2016.svg" alt="Instagram">                            
                            </a>                            
                            <!-- use the webmessage to add extra Icons to the right of the social media icons, country specific -->                           
                            <webmessage v-if="this.$root.language.wsm_Footer2020_socialMedia != 'false'"  :text="this.$root.language.wsm_Footer2020_socialMedia" searchKey="wsm_Footer2020_socialMedia" ></webmessage> 
                                  
                            
                          </div>
                    </div>
                </div>
    
                <div class="footerColumn fCol3">
    
                    <div class="footerColumnWrapper footerLinks">
            
                        <div>
                            <h4 class="flex-align-center resp-just-center">
                                <webmessage :text="this.$root.language.wsm_Footer2020_Links" searchKey="wsm_Footer2020_Links">
                                </webmessage><i class="fas fa-link"></i>
                            </h4>
                            <p class="footer-infoLinks">
                                <webmessage :text="this.$root.language.wsm_Footer2016Col_3" searchKey="wsm_Footer2016Col_3"></webmessage>
                            </p>
                        </div>
                        <div> 
                          <h4 class="footer-infoHeader flex-align-center resp-just-center" v-if="!this.$root.isMedUK">
                              <webmessage :text="this.$root.language.wsm_Footer2020_Info" searchKey="wsm_Footer2020_Info"></webmessage><i class="fas fa-info"></i>
                          </h4>
                          <p v-if="!this.$root.isMedUK">
                              <webmessage :text="this.$root.language.wsm_Footer2016Col_2" searchKey="wsm_Footer2016Col_2"></webmessage>
                          </p>
                        </div>

             
                    </div>
    
                </div>
            </div>
        </div>
    
        <div id="footerSecondContainer">
    
            <div class="footerSectionWrapper" v-if="(!this.$root.isMedUK && !this.$root.isNonShop) || this.$root.isadmin">
    
                <div class="footerColumn">
                    <div class="footerColumnWrapper">
                        <div v-if="this.$root.isThai" class="footer2020-paymentMethods ">
                            <webmessage class="flex-just-center flex-wrap" :text="this.$root.language.wsm_Thai_en_Footer2020_PaymentMethods" searchKey="wsm_Thai_en_Footer2020_PaymentMethods"></webmessage>
                        </div>
                        <div v-else class="footer2020-paymentMethods">
                            <webmessage class="flex-just-center flex-wrap" :text="this.$root.language.wsm_Footer2020_PaymentMethods" searchKey="wsm_Footer2020_PaymentMethods"></webmessage>
                        </div>
                    </div>
                </div>
                <div class="footerColumn">
                    <div class="footerColumnWrapper">
                        <div v-if="this.$root.isThai">
                            <webmessage :text="this.$root.language.wsm_Thai_en_Footer2020_delivery" searchKey="wsm_Thai_en_Footer2020_delivery"></webmessage>
                        </div>
                        <div v-else>
                            <webmessage :text="this.$root.language.wsm_Footer2020_delivery" searchKey="wsm_Footer2020_delivery"></webmessage>
                        </div>
                    </div>
                </div>
                <div class="footerColumn">
                    <div class="footerColumnWrapper">
                        <div class="footer2020-extraIcons">
                            <webmessage :text="this.$root.language.wsm_Footer2020_extraIcons" searchKey="wsm_Footer2020_extraIcons"></webmessage>
                        </div>
                    </div>
                </div>
    
            </div>
    
            <div class="noShop" v-if="this.$root.isNonShop"> </div>
    
        </div> 




  </div>
</template>

<script>

export default {
  name: 'Footer',
  components: {
  },
  mounted(){
  },
  computed: {
    isSoMeLinkAvailable: function(){
      let soMeArrayToCheck = ['facebookLink','channel','linkedin','twitterLink','instagramLink'];
      let soMeAvailable = soMeArrayToCheck.some((soMeItem) =>{
        if(this.$root[soMeItem] != undefined && this.$root[soMeItem] !=''){
          return true
        }
        
      })
     
      return soMeAvailable;
  }
}
}
</script>

<style lang="scss">
#footerNew2020{
  a{
    //color: #333;
    color: #000;
    margin: 0;
    &:hover{
      text-decoration: underline;
    }
  }
}

/* ===============================================================
      FOOTER VUE
================================================================= */
 
.medUK #footerNew2020 #footerFirstContainer{
	    background:#14619b;
}

.medUK #footerNew2020 .footerColumn h4
 {
	color:#bad6e5;
}

.medUK #footerNew2020 .footerColumn h2 a {
		font-size:1.2em;
	}

 #footerNew2020 .footerColumn .fas {
	 color: #52504d;
}

.medUK #footerNew2020 .footerColumn .fas {
	 color: #bad6e5;
}

.medUK #footerNew2020 p,
.medUK #footerNew2020 a{
	color:white;
}

 #footerNew2020 .fCol1 .companyDesc-text {
	//  margin-bottom: 12%;
}
 #footerNew2020 .fCol2 h2 a {
	 display: inline-block;
	 padding: 6% 0 6% 0;
	 font-weight: 700;
	 font-size: 1.4em;
	 margin-bottom: 0;
	 color: #241710;
}

.medUK #footerNew2020 .fCol2 h2 a {
color:#bad6e5;}

 #footerNew2020 .fCol2 .fax {
	 padding-bottom: 0;
	 padding-top: 0;
	 font-size: 1em;
}
 #footerNew2020 .fCol2 .tlf {
	 padding-bottom: 15%;
	 font-size: 1em;
}
 #footerNew2020 .fCol2 .fa-phone, #footerNew2020 .fCol2 .fa-fax {
	 font-size: 0.8em;
}
 #footerNew2020 .fCol2 .fa-facebook-square, #footerNew2020 .fCol2 .fa-youtube-square, #footerNew2020 .fCol2 .fa-instagram, #footerNew2020 .fCol2 .fa-linkedin, #footerNew2020 .fCol2 .fa-twitter, #footerNew2020 .fCol2 .fa-twitter-square, #footerNew2020 .fCol2 .fa-line {
	 color: #52504d;
	 font-family: 'Font Awesome 5 Brands' !important;
}


#footerNew2020 .soMeWrapper a img {

   width: 100%;
}


 .medUK #footerNew2020 .fCol2 .fa-facebook-square, 
 .medUK #footerNew2020 .fCol2 .fa-youtube-square, 
 .medUK #footerNew2020 .fCol2 .fa-instagram, 
 .medUK #footerNew2020 .fCol2 .fa-linkedin, 
 .medUK #footerNew2020 .fCol2 .fa-twitter, 
 .medUK #footerNew2020 .fCol2 .fa-twitter-square, 
 .medUK #footerNew2020 .fCol2 .fa-line {
	 color: #bad6e5;
}


 #footerNew2020 .fCol3 .footer-infoLinks {
	 margin-bottom: 10%;
}

 #footerNew2020 #footerSecondContainer {
	 background: #353535;
	 overflow: auto;
}

.medUK #footerNew2020 #footerSecondContainer {
	background:#00344e;
  height:30px;
}

 #footerNew2020 #footerSecondContainer .footer2020-paymentMethods {
	//  width: 70%;
	//  margin: auto;
}
 #footerNew2020 #footerSecondContainer .footer2020-paymentMethods img {
	 height: 46px;
}
 #footerNew2020 #footerSecondContainer .footer2020-extraIcons img {
	 vertical-align: middle;
	 max-height: 58px;
}
 #footerNew2020 #footerSecondContainer .levering {
	 height: 30px;
}
 #footerNew2020 #footerSecondContainer .royal_mail_levering {
	 height: 50px;
}
 #footerNew2020 .ccReplacement {
	 max-width: 230px;
	 height: auto !important;
	 margin-left: 0 !important;
}
 .uk-style #footerNew2020 .fCol1 .companyDesc-text {
	 margin-bottom: 0;
}
/* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {

	 #footerNew2020 #footerSecondContainer .footer2020-paymentMethods {
		 width: 100%;
	}
	 #footerNew2020 #footerSecondContainer .footer2020-paymentMethods img {
		 height: 35px;
	}
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1024px) {

	 #footerNew2020 .footerColumn .companyDesc-text {
		 display: block;
	}
	 #footerNew2020 .footerColumn .companyDesc-text .de {
		 width: 90%;
	}
	 #footerNew2020 .footerSectionWrapper {
		 width: auto;
		 margin: 0 auto;
	}
}
 @media only screen and (min-width: 1130px) {

	 .uk-style #footerNew2020 .footerSectionWrapper, .us-style #footerNew2020 .footerSectionWrapper, .newWidth #footerNew2020 .footerSectionWrapper {
		 width: 1100px;
	}
}
 






</style>

<style lang="scss">

#footerNew2020 {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;  

   color: #2c3e50;
   background: #d4cbb4;
   overflow: auto;

.flex-align-center{
  display: flex; 
  align-items: center;
  gap: 5px;
}
.flex-just-center{
  display: flex;
  justify-content: center;
  gap: 5px;
}
.flex-wrap{
  flex-wrap: wrap;
}
.footerLinks{
  display: flex;
  flex-direction: column;
  gap: 30px;
}

#footerFirstContainer, #footerSecondContainer{
    padding: 20px;
}
#footerFirstContainer {
	 background: #d4cbb4;
	 overflow: auto;
   padding-top: 50px;
   padding-bottom: 50px;
}
#footerSecondContainer{
  .footerSectionWrapper{
    justify-content: space-between;
    flex-wrap: nowrap;
  }
  .footerColumn{
    flex:unset;
  }
}
.companyLogo{
  display: block;
  position: relative;
  top: -30px;
}
.companyLogo .pnLogo {
	 width: 100%;
   height: 100%;
   max-width: 238px;
}
.footerColumn .companyDesc-text{
  margin-top: -20px;
}
.footerColumn{
  p{
	 //text-align: center;
	 margin: 0;
  }
  h4{
   color: #52504d;
	 font-weight: 800;
	 font-size: 1.1em;
   margin: 0;
   margin-bottom: 0.5rem;
  }
}
.footerSectionWrapper{
  display: flex;
  gap: 50px;
  //flex-wrap: wrap;
  justify-content: space-between;
  .footerColumn{
    //flex: 1;
    display: flex;
    //min-width: 250px;
  }
  .footerColumnWrapper{
    display: flex;
    flex-direction: column;
    gap: 30px;
    max-width: 300px;
  
  }

}
.soMeWrapper{
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  align-items: center;
}
.soMeWrapper a {
  width: 35px;
}
.noShop {
  height: 30px;
}



}

@media screen and (max-width: 1000px) {
  #footerNew2020{


  }

}
@media screen and (max-width: 800px){
  #footerNew2020{

    .footerSectionWrapper{
      flex-direction: column;
      text-align: center;
      .companyLogo, .companyDesc-text, p{
        text-align: center;
      }
      .footerColumn{
        justify-content: center;
      }
      .resp-just-center{
        justify-content: center;
      }
    }
    .soMeWrapper{
      justify-content: center;
    }
  }

}


</style>
